import React from 'react';
interface TabProps {
    label: string;
    isActive: boolean;
    isDisabled?: boolean;
    onClick: () => void;
}

const Tab: React.FC<TabProps> = ({ label, isActive, isDisabled, onClick }) => {
    const tabClasses = `
      tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition-all tw-duration-300 tw-ease-in-out
    `;

    const underlineClasses = `
      tw-w-[197px] tw-h-[3px] tw-rounded-tl-sm tw-rounded-tr-sm ${isActive
            ? 'tw-bg-[#0747a6]'
            : 'tw-bg-transparent tw-group-hover:tw-bg-[#0747a6]'
        }
    `;

    return (
        <div className="tw-group">
            <button
                type="button"
                className={tabClasses}
                onClick={isDisabled ? undefined : onClick}
            >
                <span>{label}</span>
            </button>
            <div className={underlineClasses} />
        </div>
    );
};
export default Tab;